"use client";

import { useEffect } from "react";

type ProductsErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

const primaryCtaClass =
  "inline-flex items-center justify-center gap-2 rounded-full bg-[#ee376a] px-6 py-3 text-sm font-semibold text-white  transition hover:-translate-y-0.5 hover:shadow-[0_22px_44px_rgba(181,95,57,0.34)]";

export default function ProductsError({ error, reset }: ProductsErrorProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] items-center justify-center px-6 py-16">
      <div className="max-w-lg rounded-[2rem] border border-[var(--color-line)] bg-[var(--color-surface)] p-8 text-center shadow-[var(--shadow-soft)]">
        <h2 className="text-3xl font-semibold text-[var(--color-ink)]">
          تعذر تحميل قطع الأثاث
        </h2>
        <p className="mt-4 text-base leading-8 text-[var(--color-ink-soft)]">
          قد تكون هناك مشكلة مؤقتة في البيانات أو الاتصال. حاول مرة أخرى.
        </p>
        <button type="button" onClick={reset} className={`${primaryCtaClass} mt-8`}>
          تحديث قائمة الأثاث
        </button>
      </div>
    </div>
  );
}
